module.exports = __webpack_public_path__ + "img/youtube.d57a47e1.svg";